import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="the-space" className="relative w-full py-32 px-6 md:px-12 overflow-hidden" data-id="element-12">
      <div className="max-w-7xl mx-auto relative flex flex-col md:flex-row items-center justify-center" data-id="element-13">
        {/* Decorative Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50,
        rotate: 5
      }} whileInView={{
        opacity: 1,
        x: 0,
        rotate: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full md:w-1/2 md:absolute md:right-0 md:top-1/2 md:-translate-y-1/2 z-0 mb-12 md:mb-0 flex justify-center md:justify-end" data-id="element-14">
          <div className="relative w-64 h-80 md:w-96 md:h-[30rem] rounded-[2rem] overflow-hidden shadow-2xl" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/mehmLP6YrSFnL1snsZNXrx/imagen_4.jpg" alt="Chrome Face Sculpture" className="w-full h-full object-cover" data-id="element-16" />
            <div className="absolute inset-0 bg-gradient-to-tr from-pink-500/20 to-transparent mix-blend-overlay" data-id="element-17" />
          </div>
        </motion.div>

        {/* Glass Content Card */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full md:w-2/3 lg:w-1/2 z-10 glass-panel rounded-[2rem] p-8 md:p-14 relative md:mr-auto" data-id="element-18">
          <h2 className="font-syncopate font-bold text-3xl md:text-4xl text-black mb-6 tracking-wider" data-id="element-19">
            THE ART OF{' '}
            <span className="text-chrome bg-clip-text text-transparent drop-shadow-sm" data-id="element-20">
              CHROME
            </span>
          </h2>
          <div className="space-y-6 text-black/80 font-light leading-relaxed text-lg" data-id="element-21">
            <p data-id="element-22">
              We don't just paint nails; we engineer wearable art. The Gloss &
              Chrome Lab is a sanctuary for those who view beauty through a
              futuristic lens.
            </p>
            <p data-id="element-23">
              Our signature liquid metal techniques and hyper-reflective
              finishes are born from a meticulous blend of high-fashion
              editorial aesthetics and cutting-edge material science.
            </p>
            <p data-id="element-24">
              Step into a space where every detail is curated, and every
              manicure is a masterpiece of modern design.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}